var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptopAltKeyboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00001 2C4.89544 2 4.00001 2.89543 4.00001 4V12.25H20V4C20 2.89543 19.1046 2 18 2H6.00001ZM11 3.25H13C13.4142 3.25 13.75 3.58579 13.75 4C13.75 4.41421 13.4142 4.75 13 4.75H11C10.5858 4.75 10.25 4.41421 10.25 4C10.25 3.58579 10.5858 3.25 11 3.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.27043 20.7831L3.83334 13.75H20.1667L21.7296 20.7831C21.8684 21.4076 21.3931 22 20.7534 22H3.24662C2.60687 22 2.13165 21.4076 2.27043 20.7831ZM9.78078 16.5C9.32191 16.5 8.92193 16.8123 8.81063 17.2575L8.31063 19.2575C8.15285 19.8886 8.63021 20.5 9.28078 20.5H14.7192C15.3698 20.5 15.8472 19.8886 15.6894 19.2575L15.1894 17.2575C15.0781 16.8123 14.6781 16.5 14.2192 16.5H9.78078Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopAltKeyboard);
export default __webpack_public_path__ + "static/media/laptop-alt-keyboard.ae3b1f319625a5ea3088d70e389f919d.svg";
export { ForwardRef as ReactComponent };